<template>
  <div
    class="page--employee"
    :style="`min-height: ${height}px`"
  >
    <Header />
    <Table />
    <Footer />
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Header from 'components/nfeImportHistory/Header'
import Table from 'components/nfeImportHistory/Table'
import Footer from 'components/nfeImportHistory/Footer'

export default {
  name: 'NfeImportHistoryPage',
  components: {
    Header,
    Table,
    Footer
  },
  computed: {
    height () {
      return document.body.offsetHeight
    }
  },
  data () {
    return {
      namespace: 'Views.RevenuesPage',
      currentStatus: null
    }
  },
  methods: {
    ...mapActions({
      errorAlert: 'snackbarAlert/error'
    }),

    handleSubmit () {
      this.submitForm = !this.submitForm
    }
  }
}
</script>
